import Component from '../../js/_Component';
import Menu from '../../js/lib/_menu';
import '../../js/_ResizeObserver';

const CNAME = 'c-block-header-caf';

export default class BlockHeaderCaf extends Component {
	private utilityMenu: HTMLElement;

	private menuElement: HTMLElement;

	private menu: Menu;

	private currentSubmenu: HTMLElement = null;

	/**
	 * Whether or not the function to display the "back to top" button is queued.
	 */
	private topButtonQueued = false;

	constructor(element: HTMLElement) {
		super(element);

		this.utilityMenu = this.element.querySelector(`.${CNAME}--utility-menu`);
		new Menu(this.utilityMenu);

		this.menuElement = this.element.querySelector(`.${CNAME}--menu`);
		this.menu = new Menu(this.menuElement, null, ['slide']);

		this.menuElement.addEventListener('menuopen', () => {
			this.menu.setLocked(true);
			// Find the current open menu.
			let button = this.element.querySelector(`.${CNAME}--button[aria-expanded="true"]`);
			this.currentSubmenu = button.parentElement.querySelector(`.${CNAME}--submenu`);
			requestAnimationFrame(() => this.updateSubmenuPosition());
		});

		this.menuElement.addEventListener('menuclose', () => {
			this.menu.setLocked(true);
		});

		this.menuElement.addEventListener('menuopened', () => {
			this.menu.setLocked(false);
		});

		this.menuElement.addEventListener('menuclosed', () => {
			this.menu.setLocked(false);
		});

		// If the search menu opens, try to send focus to the search
		this.element.querySelector(`.${CNAME}--utility-search-menu`).addEventListener('menuopen', () => {
			console.log("search open");
			let searchInput = this.element.querySelector(`.${CNAME}--search-input`) as HTMLInputElement;
			setTimeout(() => {
				searchInput.focus();
			},250);
		});

		this.element.querySelector(`.${CNAME}--search-input`).addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Enter') {
				this.submitSearch();
			}
		});
		this.element.querySelector(`.${CNAME}--search-button`).addEventListener('click', () => this.submitSearch());

		let observer = new ResizeObserver(() => this.updateSubmenuPosition());
		observer.observe(this.menuElement);

		// Make attempts to activate current activate current section
		this.activateCurrentSection();

		this.element.querySelector(`.${CNAME}--back-to-top-button`).addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});

		window.addEventListener('scroll', () => this.queueCheckShowTopButton());

		this.queueCheckShowTopButton();
	}

	queueCheckShowTopButton() {
		if (!this.topButtonQueued) {
			this.topButtonQueued = true;
			requestAnimationFrame(() => {
				this.topButtonQueued = false;

				// If scrolled down lower than the height of the menu.
				if ((window.scrollY || document.documentElement.scrollTop) > this.element.getBoundingClientRect().height) {
					this.element.classList.add('m-show-back-to-top-button');
				} else {
					this.element.classList.remove('m-show-back-to-top-button');
				}
			});
		}
	}

	submitSearch() {
		let searchInput = this.element.querySelector(`.${CNAME}--search-input`) as HTMLInputElement;
		if (!searchInput.value) {
			return;
		}
		let searchObject = {'': searchInput.value};
		window.location.href = `/search?s=${btoa(JSON.stringify(searchObject))}`;
	}

	updateSubmenuPosition() {
		if (!this.currentSubmenu) {
			return;
		}
		let width = 0;
		let rect = this.currentSubmenu.querySelector(`.${CNAME}--submenu-summary--wrapper`).getBoundingClientRect();
		if (rect.height) {
			width += rect.width;
		}
		rect = this.currentSubmenu.querySelector(`.${CNAME}--submenu-links-wrapper`).getBoundingClientRect();
		if (rect.height) {
			width += rect.width;
		}
		let maxWidth = this.menuElement.getBoundingClientRect().right - this.currentSubmenu.parentElement.getBoundingClientRect().left;
		if (width > maxWidth) {
			this.currentSubmenu.style.setProperty('right', '0');
		} else {
			this.currentSubmenu.style.setProperty('right', '');
		}
	}

	activateCurrentSection() {
		// This will attempt to do two things. Activate based on URL matching to the menu and activate based on matching slug.
		let currentPath = window.location.pathname.replace(/\/+$/, ''); // Remove trailing slashes

		// Match to links in menus
		let anchorList = this.element.querySelectorAll(`.${CNAME}--bar a.${CNAME}--submenu-summary-link, .${CNAME}--bar .${CNAME}--submenu a.button, .${CNAME}--bar a.${CNAME}--button`) as NodeList;
		anchorList.forEach((el: HTMLAnchorElement)=>{
			//console.log("anchors",el);
			let elPath = el.pathname.replace(/\/+$/, ''); // Remove trailing slashes
			if(elPath == currentPath) {
				//console.log("match");
				el.closest(`.${CNAME}--top-level-button`).querySelector(`.${CNAME}--top-button`).classList.add('m-in-section'); // Look up to the section, look down to the button.
			}
		});

		// Check if we found something
		if(this.element.querySelector('.m-in-section')){
			//console.log("Found section");
			return;
		}

		// If we didn't find it, attempt to look at the overview look and guess which section we're in.
		let overviewSections = this.element.querySelectorAll(`.${CNAME}--bar a.${CNAME}--submenu-summary-link`) as NodeList;
		overviewSections.forEach((el: HTMLAnchorElement)=>{
			let elPath = el.pathname.replace(/\/+$/, ''); // Remove trailing slashes
			let currentPathFirstSegment = currentPath.split("/")[1]; // Get the first segment

			// Loose looking for the segment. This is for cases where we might have a slash in the url or not. Content decides this. Either first or second spot.
			if((elPath.indexOf(currentPathFirstSegment) == 0) || (elPath.indexOf(currentPathFirstSegment) == 1)) {
				el.closest(`.${CNAME}--top-level-button`).querySelector(`.${CNAME}--top-button`).classList.add('m-in-section'); // Look up to the section, look down to the button.
			}
		});
	}
}

Component.register(BlockHeaderCaf, 'BlockHeaderCaf');
